// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eHYb","importantInfo":"styles_importantInfo__2MZnI"};